import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.688 11.75c0-2.023-1.094-3.883-2.844-4.922a5.71 5.71 0 0 0-5.688 0 5.68 5.68 0 0 0-2.844 4.922c0 2.05 1.067 3.91 2.844 4.95a5.71 5.71 0 0 0 5.688 0c1.75-1.04 2.844-2.9 2.844-4.95M5 11.75a6.95 6.95 0 0 1 3.5-6.043c2.16-1.258 4.813-1.258 7 0C17.66 6.965 19 9.262 19 11.75a7.02 7.02 0 0 1-3.5 6.07c-2.187 1.258-4.84 1.258-7 0A6.96 6.96 0 0 1 5 11.75m6.344-3.719c0-.355.273-.656.656-.656.355 0 .656.3.656.656v3.39l2.324 1.532c.301.219.383.629.192.93a.664.664 0 0 1-.93.164l-2.625-1.75a.67.67 0 0 1-.273-.547z"
    }, null, -1)
  ]))]))
}
export default { render: render }